export const getMonth = (month = new Date().getMonth()) => {
  const date = new Date();
  const currentYear = date.getFullYear();
  const firstDayOfTheMonth = new Date(currentYear, month, 0).getDay();

  let currentMonthCount = 0 - firstDayOfTheMonth;

  let dates = [];

  for (let i = 0; i < 42; i++) {
    currentMonthCount++;
    let newDate = new Date(currentYear, month, currentMonthCount);
    dates.push({
      date: formatDate(newDate),
      isCurrentMonth: month === newDate.getMonth(),
      isToday: date.getDate() === newDate.getDate(),
      isSelected: true,
      employees: [],
    });
  }

  return dates;
};

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export const generateDays = (year, month, rosterData = []) => {
  const weekStartsOn = 1; // Fixed to Monday
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const firstDayOfMonth =
    (new Date(year, month, 1).getDay() - weekStartsOn + 7) % 7;
  const today = new Date();
  const days = [];

  const prevMonthDays = new Date(year, month, 0).getDate();
  for (let i = firstDayOfMonth - 1; i >= 0; i--) {
    const date = `${year}-${String(month).padStart(2, "0")}-${String(
      prevMonthDays - i
    ).padStart(2, "0")}`;
    days.push({
      date,
      isCurrentMonth: false,
      employees: rosterData.filter((roster) => roster.date === date),
    });
  }

  for (let day = 1; day <= daysInMonth; day++) {
    const date = `${year}-${String(month + 1).padStart(2, "0")}-${String(
      day
    ).padStart(2, "0")}`;
    days.push({
      date,
      isCurrentMonth: true,
      isToday:
        day === today.getDate() &&
        month === today.getMonth() &&
        year === today.getFullYear(),
      employees: rosterData.filter((roster) => roster.date === date),
    });
  }

  const totalSlots = 42;
  const remainingSlots = totalSlots - days.length;
  for (let i = 1; i <= remainingSlots; i++) {
    const date = `${year}-${String(month + 2).padStart(2, "0")}-${String(
      i
    ).padStart(2, "0")}`;
    days.push({
      date,
      isCurrentMonth: false,
      employees: rosterData.filter((roster) => roster.date === date),
    });
  }

  return days;
};
